import { render, staticRenderFns } from "./truckLagbe.vue?vue&type=template&id=2b3d3090&"
import script from "./truckLagbe.vue?vue&type=script&lang=js&"
export * from "./truckLagbe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports